
import { useAuthContext } from '../hooks/useAuthContext';
import axios from 'axios';
/**
 * 
 * @param {*} id document id I want to delete
 * @param {*} thenCallback a function to run after deleting
 * it deletes only if it is not referenced anywhere
 */

/* export const _FETCH = (query) => {
    return SClient
    .fetch(query)
} */


/* export const _GETDOCUMENT = (documentId) => {
    return SClient
    .getDocument(documentId)
} */

/* export const _ADDFILE = (data)=>{
    SClient.assets
    .upload( data.fileType, data.file, { contentType: data.file.type, filename: data.file.name })
} */



export const _FETCH = async ({route, user, query, onSuccess=()=>{}, onError=()=>{}}) => {
  
    try{
        if(!route) throw Error('no route')
        if(!user) throw Error('no user')
        if(!user.token) throw Error('no token')
        if(!query) throw Error('no query')

        const response = await axios.post(route, {
            query }, {
            withCredentials: true,    
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }
          });
        
        //const json = await response.json()
        //if(!json) throw Error('no response')
        const data = response.data   
        //console.log("_FETCH SUCCESS", response)

        onSuccess(data)
        return data
    } catch(e) {
        console.log("_FETCH ERROR", e)
        onError(e)
        return ({error:e?.message})
    }
    }
    



 
/*  export const useQueryDocuments = ({...props}) => {
    return useMutation(_FETCH,{...props})
} */








